import { PageHeader, Card, Field, Input } from '../../components/ui';
import { SectionManager } from '../../components/views/SectionManager';
import { useEditorStore } from '../../store/editorStore';
import styles from './EntityPages.module.css';

/** Editor home: adventure metadata + the section manager. */
export function SectionsPage() {
  const adventure = useEditorStore((s) => s.adventure);
  const update = useEditorStore((s) => s.update);
  if (!adventure) return null;

  const meta = adventure.meta;
  const setMeta = (key: string, value: string) =>
    update((adv) => {
      adv.meta = { ...adv.meta, [key]: value || undefined };
    });

  return (
    <div className={styles.stack}>
      <PageHeader eyebrow="Editor" title="Sezioni e dati" subtitle="Metadati dell'avventura e gestione delle sezioni" />

      <Card>
        <h3>Metadati</h3>
        <div className={styles.metaGrid}>
          <Field label="Titolo">
            <Input value={adventure.title} onChange={(e) => update((a) => void (a.title = e.target.value))} />
          </Field>
          <Field label="Sottotitolo">
            <Input
              value={adventure.subtitle}
              onChange={(e) => update((a) => void (a.subtitle = e.target.value))}
            />
          </Field>
          <Field label="Copertina (percorso/URL)">
            <Input value={adventure.cover} onChange={(e) => update((a) => void (a.cover = e.target.value))} />
          </Field>
          <Field label="Livello">
            <Input value={String(meta.level ?? '')} onChange={(e) => setMeta('level', e.target.value)} />
          </Field>
          <Field label="Giocatori">
            <Input value={meta.playerCount ?? ''} onChange={(e) => setMeta('playerCount', e.target.value)} />
          </Field>
          <Field label="Durata">
            <Input value={meta.duration ?? ''} onChange={(e) => setMeta('duration', e.target.value)} />
          </Field>
          <Field label="Ambientazione">
            <Input value={meta.setting ?? ''} onChange={(e) => setMeta('setting', e.target.value)} />
          </Field>
          <Field label="Tono">
            <Input value={meta.tone ?? ''} onChange={(e) => setMeta('tone', e.target.value)} />
          </Field>
          <Field label="Tagline" className={styles.full}>
            <Input value={meta.tagline ?? ''} onChange={(e) => setMeta('tagline', e.target.value)} />
          </Field>
        </div>
      </Card>

      <Card>
        <h3>Sezioni</h3>
        <p className={styles.muted}>
          Le sezioni dell'avventura compaiono in alto, quelle di sistema in basso. Le sezioni fisse
          non si possono eliminare.
        </p>
        <SectionManager />
      </Card>
    </div>
  );
}
